import fileSaver from "file-saver";

export const getFileArrayBufferAsync = (file) => {
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      () => {
        resolve(reader.result);
      },
      false
    );
    reader.readAsArrayBuffer(file);
  });
  return promise;
};

export const saveDownloadResponse = (response, name) => {
  if (response) {
    const byteCharacters = atob(response.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: response.contentType });
    fileSaver.saveAs(blob, name ?? "Document");
  }
};
